// extracted by mini-css-extract-plugin
export default {"container":"CheckBox_container__mZLCg","checkmark":"CheckBox_checkmark__XZbnR","label":"CheckBox_label__jH0jA"};